@if (filtersForm) {
  <form (ngSubmit)="submit()" [formGroup]="filtersForm" class="mx-[-8px]">
    <mat-expansion-panel #panel
                         class="mat-elevation-z0 filter-panel bg-none"
                         hideToggle
                         [disabled]="true">
      <mat-expansion-panel-header class="pl-2 pr-0 mb-4 hover:bg-transparent cursor-default">
        <ng-content select="[filterHeader]" />
        @if (showAdditionalFilters) {
          <div class="flex flex-grow"></div>
          <app-button aria-label="Toggle filters button"
                      [style]="ButtonStyle.BASIC"
                      (click)="panel.toggle()"
                      [size]="ButtonSize.SM"
                      [iconPosition]="'suffix'"
                      [icon]="panel.expanded ? 'expand_less' : 'expand_more'">
            {{ (panel.expanded ? ('global.filter.hide' | translate) : ('global.filter.show' | translate)) + (filterCount ? ' (' + filterCount + ')' : '') }}
          </app-button>
        }
      </mat-expansion-panel-header>

      <ng-template matExpansionPanelContent>
        <div
          class="p-4 panel-content mat-elevation-z2 w-full rounded-lg grid grid-cols-[repeat(auto-fit,minmax(250px,1fr))] gap-4">
          <ng-template #container />
          <div class="flex flex-row w-full justify-between col-span-full">
            <ng-content select="[filterFooter]" />
            <div class="flex flex-row gap-2 ml-auto">
              <app-button (click)="resetForm()"
                          [style]="ButtonStyle.BASIC"
                          [size]="ButtonSize.SM"
                          aria-label="Reset filter form">
                {{ 'global.clear' | translate }}
              </app-button>
              <app-button [style]="ButtonStyle.OUTLINE"
                          [type]="ButtonType.SUBMIT"
                          [size]="ButtonSize.SM"
                          aria-label="Submit filter form">
                {{ 'global.apply' | translate }}
              </app-button>
            </div>
          </div>
        </div>
      </ng-template>
    </mat-expansion-panel>
  </form>
} @else {
  <div>Loading form...</div>
}
